import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';

export function FDAvailabilityFilter({ selected = [], onChange }) {
  const options = ['0', '1', '2', '3+'];

  const handleChange = (value, checked) => {
    const newSelected = checked
      ? [...selected, value]
      : selected.filter(v => v !== value);
    onChange(newSelected);
  };

  return (
    <div className="flex flex-col gap-1 min-w-[200px]">
      <label className="text-sm font-medium text-gray-700">FD Availability</label>

      <div className="border rounded-md p-3 bg-white space-y-2">
        {options.map(option => (
          <label key={option} className="flex items-center gap-2 cursor-pointer">
            <Checkbox
              checked={selected.includes(option)}
              onCheckedChange={(checked) => handleChange(option, checked)}
            />
            <span className="text-sm">{option}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
